import React from 'react';

const SearchField = props => (
  <div className="search">
    <form className="search-form">
      <div className="form-group search-control">
        <i className="icon-budicon-489" />
        <input {...props} className="search-input form-control" />
      </div>
    </form>
  </div>
);

export default SearchField;



// WEBPACK FOOTER //
// ./src/pages/press/components/SearchField/SearchField.js